@import './tokens.css';

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  background-color: var(--bg-canvas);
  color: var(--text-primary);
  font-family: var(--font-sans);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

body {
  background-image:
    radial-gradient(circle at 10% 6%, rgba(134, 242, 228, 0.22), transparent 36%),
    radial-gradient(circle at 90% 12%, rgba(220, 225, 255, 0.45), transparent 40%);
  background-attachment: fixed;
}

::selection {
  background-color: var(--primary-fixed);
  color: var(--primary);
}

h1,
h2,
h3,
h4,
.fontDisplay {
  font-family: var(--font-display);
  letter-spacing: -0.02em;
}

button,
input,
select,
textarea {
  font-family: inherit;
  color: inherit;
}

button {
  transition:
    background-color 0.16s ease,
    border-color 0.16s ease,
    color 0.16s ease,
    box-shadow 0.16s ease,
    transform 0.12s ease;
}

button:active:not(:disabled) {
  transform: scale(0.99);
}

/* Utilidad global para guarismos financieros tabulares */
.tabularNums {
  font-variant-numeric: tabular-nums;
}

.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 500,
    'GRAD' 0,
    'opsz' 24;
  vertical-align: middle;
  line-height: 1;
}
